import React, { useState, useEffect } from 'react';
import { FilterWidget, GridView, SimpleView, Widget, Table, FormSelect, CompositeView } from '@digital/ui';
import {
  searchValues,
  RelatorioSegurosGarantias,
  SeguroGarantiaFilter,
  relatorioExportExcel,
} from './@app/../../../api/relatorioSegurosGarantias';
import { ColumnProps } from 'antd/lib/table';
import { SearchButton, ExcelButton } from '../../components/FormButtons';
import { getAllStatusSeguroGarantiaOptions } from '@app/api/status';
import PerfectScrollbar from 'react-perfect-scrollbar';

const RelatorioSegurosGarantias = () => {
  const [items, setItems] = useState<RelatorioSegurosGarantias[]>();
  const [getList, setGetList] = useState<boolean>(true);

  useEffect(() => {
    var obj = {} as SeguroGarantiaFilter;
    handleFilter(obj);
  }, [getList]);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Contrato',
      dataIndex: 'numeroContrato',
      width: '10%',
    },
    {
      title: 'Nome Fornecedor',
      dataIndex: 'fornecedor',
      width: '25%',
    },
    {
      title: 'Tipo de Seguro/Garantia',
      dataIndex: 'tipoDocumento',
      width: '20%',
    },
    {
      title: 'Início Vigência',
      dataIndex: 'vigenciaInicio',
      width: '15%',
    },
    {
      title: 'Fim Vigência',
      dataIndex: 'vigenciaFim',
      width: '15%',
    },
    {
      title: 'Status Apólice',
      dataIndex: 'status',
      width: '15%',
    },
  ];

  const handleFilter = (values: SeguroGarantiaFilter) => {
    searchValues(values).then(resp => resp && setItems(resp));
  };

  const handleExcel = async (values: SeguroGarantiaFilter) => {
    relatorioExportExcel(values);
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView onSubmit={handleFilter}>
          <FilterWidget
            active={[]}
            actions={[
              <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
              <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />,
            ]}
            title="Filtros">
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .startsWith(input.toLowerCase());
              }}
              mode="multiple"
              label="Status Apólice"
              getOptions={getAllStatusSeguroGarantiaOptions}
              name="status"
              span={4}
            />
          </FilterWidget>
          <Widget title="Relatório de Seguros e Garantias">
            <PerfectScrollbar>
              <Table columns={columns} dataSource={items || []} pagination={{pageSize: 100}} />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default RelatorioSegurosGarantias;
